"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useState } from "react";
import { Map, Globe, X, Phone, Calendar, Mail } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const regions = [{
  name: "Lombardia",
  provinces: "Milano, Bergamo, Brescia, Como, Cremona, Lecco, Lodi, Mantova, Monza, Pavia, Sondrio, Varese"
}, {
  name: "Veneto",
  provinces: "Venezia, Belluno, Padova, Rovigo, Treviso, Verona, Vicenza"
}, {
  name: "Piemonte",
  provinces: "Torino, Alessandria, Asti, Biella, Cuneo, Novara, Verbano-Cusio-Ossola, Vercelli"
}, {
  name: "Emilia-Romagna",
  provinces: "Bologna, Ferrara, Forlì-Cesena, Modena, Parma, Piacenza, Ravenna, Reggio Emilia, Rimini"
}, {
  name: "Liguria",
  provinces: "Genova, Imperia, La Spezia, Savona"
}, {
  name: "Friuli-Venezia Giulia",
  provinces: "Trieste, Gorizia, Pordenone, Udine"
}, {
  name: "Trentino-Alto Adige",
  provinces: "Trento, Bolzano"
}, {
  name: "Valle d'Aosta",
  provinces: "Aosta"
}, {
  name: "Toscana",
  provinces: "Firenze, Arezzo, Grosseto, Livorno, Lucca, Massa-Carrara, Pisa, Pistoia, Prato, Siena"
}];
export default function Receptionschedulecarousel() {
  const [selectedRegion, setSelectedRegion] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCardClick = (regionName: string) => {
    setSelectedRegion(regionName);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedRegion(null);
  };
  return <section data-section-id="255117" id="receptionschedulecarousel" className="relative w-full bg-slate-50 text-foreground py-24 md:py-32 overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[60%] h-[60%] rounded-lg bg-primary/5 blur-[120px] animate-pulse duration-[10000ms]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[60%] h-[60%] rounded-lg bg-[#FF00E5]/5 blur-[120px] animate-pulse duration-[8000ms]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <Badge variant="secondary" className="mb-6 bg-blue-100 text-blue-700 border-none font-sans px-4 py-1 shadow-sm animate-in fade-in slide-in-from-bottom-4 duration-700">
            <Globe className="w-4 h-4 mr-2" />
            Copertura Territoriale
          </Badge>
          <h2 className="text-4xl md:text-6xl font-bold font-default text-slate-900 mb-6 tracking-tight transition-all duration-500">
            Consulenze in Presenza su Tutto il Nord Italia
          </h2>
          <p className="text-xl text-slate-600 font-sans max-w-2xl mx-auto leading-relaxed">
            La nostra rete di professionisti garantisce una presenza capillare su tutto il territorio settentrionale e centrale, offrendo supporto diretto e personalizzato in ogni provincia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {regions.map((region, i) => <Card key={i} data-index={i} onClick={() => handleCardClick(region.name)} className="bg-white/80 backdrop-blur-xl border-slate-200 shadow-md hover:shadow-xl hover:border-primary/40 hover:-translate-y-2 transition-all duration-300 group rounded-lg overflow-hidden relative cursor-pointer">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              <CardHeader className="pb-4 relative z-10">
                <div className="flex items-center justify-between mb-4">
                  <div className="p-3 rounded-lg bg-slate-100 text-primary group-hover:bg-primary group-hover:text-white transition-all duration-500">
                    <Map className="w-6 h-6" />
                  </div>
                </div>
                <CardTitle className="text-2xl font-bold font-default text-slate-900 tracking-tight group-hover:text-primary transition-colors duration-300">
                  {region.name}
                </CardTitle>
              </CardHeader>
              <CardContent className="relative z-10">
                <p className="text-slate-600 font-sans text-sm leading-relaxed mb-4">
                  {region.provinces}
                </p>
                <div className="h-1 w-0 bg-gradient-to-r from-primary to-accent group-hover:w-full transition-all duration-700 ease-in-out" />
              </CardContent>
            </Card>)}
        </div>
      </div>

      {isModalOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-2 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-300">
          <div className="absolute inset-0" onClick={closeModal} />
          <div className="relative w-full max-w-2xl max-h-[90vh] overflow-y-auto bg-white rounded-lg shadow-2xl animate-in zoom-in-95 duration-300">
            <div className="absolute top-4 right-4 z-20">
              <button onClick={closeModal} className="p-2 rounded-lg hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors">
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <div className="p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className="p-3 rounded-lg bg-primary/10 text-primary">
                  <SafeHydrate><Calendar className="w-8 h-8" /></SafeHydrate>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-slate-900 font-default">
                    Prenota in {selectedRegion}
                  </h3>
                  <p className="text-slate-500 text-sm">Consulenza Territoriale</p>
                </div>
              </div>
              
              <div className="space-y-4 mb-8">
                <p className="text-slate-600 leading-relaxed">
                  Hai selezionato la regione <strong>{selectedRegion}</strong>. Siamo disponibili per appuntamenti in presenza in tutte le province indicate.
                </p>
                
                <div className="bg-slate-50 p-4 rounded-lg border border-slate-100">
                  <div className="flex items-center gap-3 text-primary font-semibold mb-2">
                    <Phone className="w-4 h-4" />
                    <span>Contattami per coordinare un incontro, sia in presenza che da remoto.</span>
                  </div>
                  <p className="text-sm text-slate-500 mb-4">
                    Sono a tua disposizione per definire la soluzione più adatta alle tue esigenze e pianificare il nostro appuntamento.
                  </p>
                  <div className="flex flex-col gap-2">
                    <Link to="tel:+39498640662" className="flex items-center gap-2 text-primary font-semibold hover:underline">
                      <Phone className="w-4 h-4" />
                      049 86 40 662
                    </Link>
                    <Link to="mailto:info@worldimmigration.it" className="flex items-center gap-2 text-primary font-semibold hover:underline">
                      <Mail className="w-4 h-4" />
                      info@worldimmigration.it
                    </Link>
                  </div>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-3">
                <button onClick={closeModal} className="flex-1 inline-flex items-center justify-center px-6 py-3 bg-slate-100 text-slate-700 font-semibold rounded-lg hover:bg-slate-200 transition-all">
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        </div>}
    </section>;
}